import Sortable from "sortablejs/modular/sortable.core.esm.js"
import { post } from "shared/lib/api"

export default function triggerFieldsSortable(updateUrl) {
  const _url = updateUrl

  function reorderTriggerFields() {
    let triggerFieldIds = []
    document.querySelectorAll(".field-list li").forEach(triggerField => {
      triggerFieldIds.push(triggerField.dataset["triggerFieldId"])
    })

    post(_url, { item_ids: triggerFieldIds })
      .then(() => {
        App.Scripts.partners.displayFlash("Trigger fields reordered")
      })
      .catch(() => {
        App.Scripts.partners.displayFlash("There has been an error reordering the trigger fields, try again!", "error")
      })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderTriggerFields,
  })
}
